import { useSyncExternalStore } from 'react'
import { useBoardCtx } from '@/board/context'
import { useI18n } from '@/i18n/i18n'
import { sessionName, type SessionTitle } from './describe'

/** A conversation's title (or the untitled name), for chips naming a conversation on the board. */
export function useSessionTitle(): SessionTitle {
  const { sessions } = useBoardCtx()
  const { t } = useI18n()
  const snap = useSyncExternalStore(sessions.subscribe, sessions.getSnapshot)
  return (id) =>
    sessionName(
      snap.sessions.find((x) => x.id === id),
      t('session.untitled'),
    )
}
